import { OgCustomInputsModule } from 'projects/og-custom-inputs/src/public_api';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import { MatFormFieldControl, MatSelectChange } from '@angular/material';
import { Component, OnInit, forwardRef, OnDestroy, Input, Optional, Self, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, NgControl, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { FocusMonitor } from '@angular/cdk/a11y';
import { OgCustomInput } from '../OgCustomInput';
import { timeMaskPipe } from '../mask-pipes';

@Component({
  selector: 'og-boolean-input',
  template: `<ng-container *ngIf="isMaterialFormField; else elseTemplate">
  <mat-select [placeholder]="placeholder" [(value)]="value" (selectionChange)="matSelectChanged($event)">
    <mat-option [value]=true>{{trueLabel()}}</mat-option>
    <mat-option [value]=false>{{falseLabel()}}</mat-option>
  </mat-select>
</ng-container>
<ng-template #elseTemplate>
  {{placeholder}} <select #selectedBoolean class="select-text og-boolean-input" [disabled]="disabled"
    [value]="value" (change)="matSelectChanged({value: selectedBoolean.value})">
    <option [value]=true>{{trueLabel()}}</option>
    <option [value]=false>{{falseLabel()}}</option>
  </select>
</ng-template>
`,
  styles: [``],
  providers: [{provide: MatFormFieldControl, useExisting: OgBooleanInputComponent}],
})
export class OgBooleanInputComponent extends OgCustomInput implements MatFormFieldControl<String>, ControlValueAccessor, OnInit, OnDestroy {
  static nextId = 0;
  controlType = 'og-boolean-input';
  id = `og-boolean-input-${OgBooleanInputComponent.nextId++}`;
  autofilled?: boolean;
  public timeMask;
  @Input() opcaoSim;
  @Input() opcaoNao;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    protected fm: FocusMonitor,
    protected elRef: ElementRef
  ) {
    super(ngControl, fm, elRef);
    this.timeMask = {
      mask: [/\d/, /\d/, ':', /\d/, /\d/],
      keepCharPositions: true,
      pipe: timeMaskPipe,
    };
  }

  matSelectChanged(e) {
    this.propagateChanges(JSON.parse(e.value));
    this.checkErrorState();
  }

  onContainerClick(event: MouseEvent): void {
    if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      // this.elRef.nativeElement.querySelector('mat-select').focus();
      // this.elRef.nativeElement.querySelector('input').focus();
    }
  }

  trueLabel() {
    return this.opcaoSim || 'Sim';
  }

  falseLabel() {
    return this.opcaoNao || 'NÃ£o';
  }


}
